import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {Subscription} from 'rxjs';

import {Filter} from '../../../../shared/model/filter.model';
import { NzModalRef, NzModalService } from 'ng-zorro-antd';
import { NzNotificationService } from 'ng-zorro-antd';
import { TableService } from '../../../../shared/services/table.service';

import {NewContractComponent} from '../new-contract/new-contract.component';
import {SubprojectContractService} from '../../../services/subproject-contract.service';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';

@Component({
  selector: 'app-subproject-contract',
  templateUrl: './subproject-contract.component.html',
  styleUrls: ['./subproject-contract.component.css']
})
export class SubprojectContractComponent implements OnInit {

  dateFormat = "yyyy-mm-dd"
  
  listSubscription : Subscription;
  @Input() selectedProjectId : number;

  // campos a mostrar
  fdView : string = "qtt"

  filters : Array<Filter> = []

  itemList : any;
  itemDisplay : any;

  view = "A"

  constructor(private tableSvc : TableService, 
              private modalService: NzModalService, 
              private notification: NzNotificationService,
              private listService : SubprojectContractService,
              private editService : SubprojectContractService
              ) { }

  ngOnInit() {
    this.addFilter({key: 'id_subproject', value: this.selectedProjectId}) 
    this.getListData();
  }



  getListData() {
    this.listSubscription = this.listService.getContracts(this.filters)
    .subscribe((data : any) => {
        console.log(data);
        this.itemList = data;
        this.itemDisplay = data;
    });    
  }

  onListTypeChange(id) {
    this.addFilter({key: 'status', value: id});
    this.getListData();
  }

  onFieldViewChange(id) {
    this.fdView = id;
  }

  newTransaction(id) {
     let title
     if (id != 0) {
        title = "Edit Contract"
     } else {
        title = "New Contact"
     }
     const modal = this.modalService.create({
        nzTitle: title,
        nzContent: NewContractComponent,
        nzComponentParams: {
          subprojectId : this.selectedProjectId,
          contractId: id,
          subprojectEdit : false
        },
     });
     const instance = modal.getContentComponent();
     modal.afterClose.subscribe(result => this.getListData());
  }

  Delete(id) {
  	this.editService.delete(id)
      .subscribe((data : any) => {
          if (data.result === "Success") {
              this.notification.blank("Success", "deleted successfully");
           } else {
              this.notification.blank("Success", "deleted successfully");
           }
           this.getListData();
    });
  }

  addFilter(obj : Filter) {
    
    let index = this.filters.findIndex(x => x.key == obj.key);
    if (index === -1) {
       this.filters.push(obj); 
    } else {
       this.filters[index].value = obj.value;
    }        
  }

  sort1(sortAttribute: any) {
        this.itemDisplay = this.tableSvc.sort(sortAttribute, this.itemDisplay);
  }

  ngOnDestroy() {
  	this.listSubscription.unsubscribe()
  }

  getFile() {
     let head = []
     for (var i = 0; i < this.itemDisplay.keys.length; ++i) {
       head.push(this.itemDisplay.keys[i]);
     }
     this.csvOptions.headers = head;
     new  AngularCsv(this.itemDisplay, "SubProject List", this.csvOptions);
  }

  csvOptions = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalseparator: ',',
      showLabels: true,
      showTitle: true,
      //title: 'Your Holiday List :',
      useBom: true,
      noDownload: false,
      headers: ["Holiday ID", "Holiday Date", "Holiday Comment", "Holiday Status"]
  };


}
